import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse, UnderwritingInfoType } from "types";
import { float2Normalizer } from "validators";

type UseUpdateUnderwritingCardInfoMutation = {
	onSuccess?: () => void;
};

const useUpdateUnderwritingCardInfoMutation = ({
	onSuccess,
}: UseUpdateUnderwritingCardInfoMutation = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		(data: UnderwritingInfoType) => {
			const merchantInfo = {
				visa_mc_discover_amv: float2Normalizer(
					data?.visaMcDiscover_AMV,
				),
				visa_mc_discover_avt: float2Normalizer(
					data?.visaMcDiscover_AVT,
				),
				visa_mc_discover_ht: float2Normalizer(data?.visaMcDiscover_HT),
				amex_AMV: float2Normalizer(data?.amex_AMV),
				amex_AVT: float2Normalizer(data?.amex_AVT),
				amex_HT: float2Normalizer(data?.amex_HT),
				funding_type: data?.fundingType,
				is_daily_discount: data?.isDailyDiscount,
			};

			return merchantInfoService.saveUnderwritingCardInfo({
				merchantInfo,
				applicationId: data?.applicationId,
			});
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess() {
				onSuccess?.();

				dispatch(
					uiActions.showSuccessNotification({
						title: "Form has been saved successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateUnderwritingCardInfoMutation;
